import { render, staticRenderFns } from "./BookerDashboard.vue?vue&type=template&id=ced32a0e"
import script from "./BookerDashboard.vue?vue&type=script&lang=js"
export * from "./BookerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports